import React from 'react';
import styled from 'styled-components';
import { config } from '@keytrade/functions';
import { Button } from '@keytrade/components-button';

import useTranslations from '@/hooks/useTranslations';

const { list: colors } = config.colors;

const SaveFiltersContainer = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 17px 20px 16px 20px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.08),
    0px 8px 16px 0px rgba(0, 0, 0, 0.14);
  background-color: ${colors.White};
`;

export type SaveFilterType = {
  closeFilterPanel: () => void;
};

const SaveFilter: React.FC<SaveFilterType> = ({ closeFilterPanel }) => {
  const { t } = useTranslations('filter');

  return (
    <SaveFiltersContainer>
      <Button size='lg' onClick={closeFilterPanel} fullWidth>
        {t('save_filters')}
      </Button>
    </SaveFiltersContainer>
  );
};

export default SaveFilter;
